import React, { useState, useEffect, useRef } from "react";
import "./featuredList.css";
import { getYoutubeRecommPlaylist } from "../api/core";
import { Link } from "react-router-dom";
import LazyImg from "../lazy/lazy";
import Global from "../../global";
import { useTranslation } from "react-i18next";
import { formatUTCDate } from "../javascript/function";
const YoutubeList = (props) => {
  const init = { playlist: [] };
  const mounted = useRef(false);
  const [flPlay, SetFLPlay] = useState(init);
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const { t } = useTranslation(["translation"]);
  useEffect(() => {
    mounted.current = true;
    const playlistDetail = async () => {
      /* eslint-disable no-unused-vars */
      const result = await getYoutubeRecommPlaylist().then(
        (result) => {
          if (mounted.current) {
            SetFLPlay(result.data);
            SetError(false);
          }
        },
        (error) => {
          if (mounted.current) {
            SetError(true);
          }
        }
      );
      /* eslint-disable no-unused-vars */
    };
    const recomFinal = async () => {
      const res = await playlistDetail();
      isLoading(false);
    };

    recomFinal();

    return () => {
      mounted.current = false;
    };
  }, []);

  if (!error && !loading && flPlay.size !== 0) {
    return (
      <div
        className="featuredList youtube_player"
        style={{ paddingTop: Global.TYPE === "News" ? "0px" : "" }}
      >
        <div className="featured_header">
          {" "}
          <h4>{t("label_latest_news")}</h4>
        </div>
        <div
          id="viewtube_related_videos-2"
          className="widget widget-video widget_viewtube_related_videos"
        >
          <ul className="sidebar-related-video">
            {flPlay.size !== 0
              ? flPlay.items.map((item, index) => (
                  <li key={index}>
                    <div className="related-video-thumb">
                      <Link
                        to={
                          "/" +
                          props.app +
                          "/videopage/" +
                          item.contentDetails.videoId
                        }
                      >
                        <LazyImg
                          src={item.snippet.thumbnails.medium.url}
                          alt="realimg"
                          orient="landscape"
                          className={Global.BORDER ? "" : "no-border"}
                        />{" "}
                      </Link>
                    </div>
                    <div className="related-video-content">
                      <p>
                        <Link
                          to={
                            "/" +
                            props.app +
                            "/videopage/" +
                            item.contentDetails.videoId
                          }
                        >
                          {item.snippet.title}
                        </Link>
                      </p>
                      <div className="d-flex video-meta-bottom">
                        {formatUTCDate(item.contentDetails.videoPublishedAt)}
                      </div>
                    </div>
                  </li>
                ))
              : ""}
          </ul>
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default YoutubeList;
